/**
 * Get the CSS className for the user's preferred font
 */
export const getFontClassName = (preferredFont?: string): string => {
  switch (preferredFont) {
    case 'fixedsys':
      return 'fixedsys-text';
    case 'alexfont':
      return 'alexfont-text';
    default:
      return '';
  }
};

/**
 * Get the CSS className for the editor container
 */
export const getEditorFontClassName = (preferredFont?: string): string => {
  switch (preferredFont) {
    case 'fixedsys':
      return 'editor-fixedsys';
    case 'alexfont':
      return 'editor-alexfont';
    default:
      return '';
  }
};

/**
 * Get the font family string for inline styles
 */
export const getFontFamily = (preferredFont?: string): string | undefined => {
  switch (preferredFont) {
    case 'fixedsys':
      return "'Fixedsys', 'Courier New', monospace";
    case 'alexfont':
      return "'Alexfont', sans-serif";
    default:
      return undefined;
  }
};
